// extracted by mini-css-extract-plugin
export default {"emptyState":"ConflictCheckResults_emptyState__9FZSr"};